import React from 'react';

const STATUS_CLASS = {
  normal: 'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-300',
  dikkat: 'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-300',
  risk: 'border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-700 dark:bg-rose-900/20 dark:text-rose-300',
  kritik: 'border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-700 dark:bg-rose-900/20 dark:text-rose-300'
};

function Badge({ label, value, tone = 'normal' }) {
  return (
    <span className={`inline-flex items-center gap-2 rounded-lg border px-3 py-1.5 text-xs font-semibold ${STATUS_CLASS[tone] || STATUS_CLASS.normal}`}>
      <span>{label}</span>
      <span className="font-black">{value}</span>
    </span>
  );
}

export default function UnitAmountHealthStrip({ data, onGenerate, generating = false }) {
  const status = String(data?.status || 'dikkat').toLowerCase();
  const updatedAt = data?.updatedAt
    ? new Date(data.updatedAt).toLocaleString('tr-TR')
    : 'Bilinmiyor';

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-[#101922]">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <div>
          <h3 className="text-sm font-black text-slate-900 dark:text-white">Unit & Amount Sağlık</h3>
          <p className="text-xs text-slate-500 dark:text-slate-400">
            Kaynak: <code>/api/admin/dashboard/unit-amount/health</code>
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onGenerate}
            disabled={generating || !onGenerate}
            className="rounded-md border border-slate-300 px-2.5 py-1 text-xs font-semibold text-slate-700 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            {generating ? 'Üretiliyor...' : 'Üret'}
          </button>
          <p className="text-xs text-slate-500 dark:text-slate-400">Güncelleme: {updatedAt}</p>
        </div>
      </div>
      <div className="mb-3 flex flex-wrap gap-2 overflow-x-auto pb-1">
        <Badge label="Durum" value={status.toUpperCase()} tone={status} />
        <Badge label="Tarif" value={Number(data?.recipeCount || 0).toLocaleString('tr-TR')} tone={status} />
        <Badge label="Mutfak" value={Number(data?.kitchenCount || 0).toLocaleString('tr-TR')} tone={status} />
        <Badge label="Kontrol" value={Number(data?.checkCount || 0).toLocaleString('tr-TR')} tone={status} />
        <Badge label="Hata" value={Number(data?.failCount || 0).toLocaleString('tr-TR')} tone={Number(data?.failCount || 0) > 0 ? 'risk' : 'normal'} />
      </div>
      <p className="text-xs text-slate-600 dark:text-slate-300">{String(data?.note || 'Durum bilgisi bekleniyor.')}</p>
    </section>
  );
}
